// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__Y5cGH","input":"Input_input__XKdah","label":"Input_label__ENGik","error":"Input_error__ki+lY"};